import TwitterShare from "../../../../content/twitter-share";
import * as React from 'react';
export default {
  TwitterShare,
  React
};